// extracted by mini-css-extract-plugin
export default {"wrapper":"not-found_wrapper__JSOyA","img":"not-found_img__lhOJy","desc":"not-found_desc__7CtN5"};